module.exports = __webpack_public_path__ + "img/sprite.b2b80182.svg";